import { mutate }    from 'swr';
import axios         from 'axios';
import { Notistack } from '@shared/components/Notistack/Notistack';
import { SERVICES } from '@shared/constants/apiConfig';
import { IStipType } from '@shared/interfaces';

const path = `/${SERVICES.DOCUMENT}/stipTypes`; 

export const requestCreateStipType = (stipType: IStipType) => {
  return mutate(path, async() => {
    try {
      await axios.post(path, stipType);
      Notistack.successMessage('Stip Type - Created Successfully');
    } catch {
      Notistack.generalError();
    }
  });
};

export const requestUpdateStipType = (stipType: IStipType) => {
  return mutate(path, async() => {
    try {
      await axios.put(path, stipType);
      Notistack.successMessage('Stip Type - Updated Successfully');
    } catch {
      Notistack.generalError();
    }
  });
};

export const requestDeleteStipType = (stipTypeId = '') => {
  return mutate(path, async() => {
    try {
      await axios.delete(`${path}/${stipTypeId}`);
      Notistack.successMessage('Stip Type - Deleted Successfully');
    } catch {
      Notistack.generalError();
    }
  });
};
